import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { font, spacing } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { navigateToLastRacesPath } from '@core/State/Navigation/helpers/navigateToLastRacesPath'
import { navigateToLastSportsPath } from '@core/State/Navigation/helpers/navigateToLastSportsPath'
import { type FilterContent, MyBetsTab } from '../../types'
import SkeletonCardLoader from './assets/SkeletonCardLoader.svg'

export const NoBets: React.FC<{ filterContent: FilterContent; activeTab: MyBetsTab }> = ({
  filterContent,
  activeTab,
}) => {
  const isPendingTab = activeTab === 'pending'
  const headerText = isPendingTab
    ? `No ${filterContent} Pending Bets`
    : `No ${filterContent} Bets Found`
  const showLink = isPendingTab

  return (
    <WrapperStyled>
      <div>
        <img src={SkeletonCardLoader} width='231' height='142' alt='Empty Bonus List' />
      </div>

      <div>
        <div>{headerText}</div>

        <div>
          <p>Bets you’ve placed will appear here</p>
        </div>

        {showLink && (
          <Flex alignItems='center' justifyContent='center' gap={spacing.sm}>
            {filterContent === 'Racing' && (
              <Button
                color='primary'
                onClick={() => {
                  navigateToLastRacesPath()
                }}
                size='xs'
              >
                <Icon name='CustomRacing' />
                Racing
              </Button>
            )}
            {filterContent === 'Sports' && (
              <Button
                color='primary'
                onClick={() => {
                  navigateToLastSportsPath()
                }}
                size='xs'
              >
                <Icon name='CustomJersey8' />
                Sports
              </Button>
            )}
          </Flex>
        )}
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  //svg
  ' > div:nth-of-type(1)': {
    paddingTop: '10vh',
  },

  //body
  ' > div:nth-of-type(2)': {
    //title
    '> div:nth-of-type(1)': {
      display: 'flex',
      justifyContent: 'center',
      fontFamily: font.family.primary,
      fontWeight: font.weight.semibold,
      fontSize: font.size.lg.fontSize,
      lineHeight: font.size.lg.lineHeight,
      marginTop: spacing.lg,
    },
    //paragraph
    '> div:nth-of-type(2)': {
      display: 'flex',
      justifyContent: 'center',

      p: {
        marginTop: 0,
        marginBottom: spacing.md,
        fontFamily: font.family.primary,
        fontWeight: font.weight.regular,
        fontSize: font.size.lg.fontSize,
        lineHeight: font.size.lg.lineHeight,
      },
    },
    '> div:nth-of-type(3)': {
      button: { flex: 1 },
    },
  },
})
